module.exports = __webpack_public_path__ + "static/img/intro4.d7699f40.png";